export const FORBIDDEN_COMMENT_PATTERNS: RegExp[] = [
  // Основные запрещенные слова
  /(^|[^а-яё])(криминал)($|[^а-яё])/i,
  /(^|[^а-яё])(судим)($|[^а-яё])/i,
  /(^|[^а-яё])(краж[аёиуы]{0,2})($|[^а-яё])/i,
  /(^|[^а-яё])(ук)($|[^а-яё])/i,
  /(^|[^а-яё])(наркотик[аи]?)($|[^а-яё])/i,
  /(^|[^а-яё])(грабеж)($|[^а-яё])/i,
  /(^|[^а-яё])(привлекался)($|[^а-яё])/i,
  /(^|[^а-яё])(угон)($|[^а-яё])/i,
  /(^|[^а-яё])(убийств)[ао]?($|[^а-яё])/i,
  /(^|[^а-яё])(статья)($|[^а-яё])/i,
  /(^|[^а-яё])(розыск)($|[^а-яё])/i,

  /(^|[^0-9])(110)($|[^0-9])/,
  /(^|[^0-9])(111)($|[^0-9])/,
  /(^|[^0-9])(126)($|[^0-9])/,
  /(^|[^0-9])(105)($|[^0-9])/,
  /(^|[^0-9])(127)($|[^0-9])/,
  /(^|[^0-9])(131)($|[^0-9])/,
  /(^|[^0-9])(132)($|[^0-9])/,
  /(^|[^0-9])(133)($|[^0-9])/,
  /(^|[^0-9])(134)($|[^0-9])/,
  /(^|[^0-9])(135)($|[^0-9])/,
  /(^|[^0-9])(162)($|[^0-9])/,
  /(^|[^0-9])(205)($|[^0-9])/,
  /(^|[^0-9])(209)($|[^0-9])/,
  /(^|[^0-9])(210)($|[^0-9])/,
  /(^|[^0-9])(223)($|[^0-9])/,
  /(^|[^0-9])(228)($|[^0-9])/,
  /(^|[^0-9])(229)($|[^0-9])/,
  /(^|[^0-9])(242)($|[^0-9])/,

  /(^|[^0-9])(103)($|[^0-9])/,
  /(^|[^0-9])(117)($|[^0-9])/,
]

export const findForbiddenWords = (text: string): string[] => {
  const matchedForbiddenPatterns = FORBIDDEN_COMMENT_PATTERNS.map((pattern) => text.match(pattern)).filter((match) => !!match) as RegExpMatchArray[]

  return matchedForbiddenPatterns.reduce((arr: string[], match) => [...arr, match[2] as string], [])
}
